import dayjs from 'dayjs';
import { ROUTER_NAME } from '../enums/router';

const requiredAuth = (vuexStore) => async (to, from, next) => {
	const authState = vuexStore.state.auth;
	const meState = vuexStore.state.me;
	const isAuthenticatedBefore = Object.keys(meState.data).length === 0 && authState.tokens.accessToken;
	const isLoginPage = to.name === ROUTER_NAME.LOGIN;

	// if user is authenticated before, then get user info
	if (isAuthenticatedBefore) {
		await vuexStore.dispatch('me/getMe');

		const diffDayNumber = dayjs().diff(meState.data.password_changed_at, 'day');
		const dayLeftNumber = (90 - diffDayNumber);

		if (dayLeftNumber > 0 && dayLeftNumber <= 7) {
			vuexStore.dispatch('toast/showToast', {
				id: 'warn_password_expire',
				header: 'Warning',
				content: `You have ${dayLeftNumber} days left to change your password. we suggest you to change your password every 90 days.`,
				type: 'warning',
				timeout: 10000000000,
			});
		}
	}

	if (authState.isLoggedIn && isLoginPage) {
		// try to come to login page, but is authenticated
		// redirect to dashboard page
		return next({
			path: '/dashboard',
		});
	} else if (to.meta.requireAuth && !authState.isLoggedIn) {
		// when access require auth page but is not login yet
		// redirect to login page
		return next({
			path: '/login',
		});
	} else if (to.meta.requireRoles && !to.meta.requireRoles.includes(meState.data.role)) {
		// when user don't have permission to access the pages
		// redirect to 403 pages
		return next({
			path: '/403',
		});
	}

	return next();
};

export default requiredAuth;